import React from 'react';
import { motion } from 'framer-motion';
import { AppStoreButton } from './AppStoreButton';
export function HeroSection() {
  return <section className="pt-32 pb-20 px-6 bg-white flex flex-col items-center text-center overflow-hidden" data-id="element-31">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-32">
        <h1 className="text-5xl md:text-7xl font-black tracking-tight text-black mb-2" data-id="element-33">
          For GLP-1 Journeys
        </h1>
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-black mb-8" data-id="element-34">
          not just weight logs
        </h2>

        <div className="flex flex-col items-center mb-10" data-id="element-35">
          <span className="text-4xl font-black text-black" data-id="element-36">#1</span>
          <span className="text-xl font-bold text-gray-600" data-id="element-37">
            Trusted GLP-1 Tracker
          </span>
        </div>

        <div className="mb-16" data-id="element-38">
          <AppStoreButton data-id="element-39" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/xsWzmFkKCuANVV71YA1FGR/0x0ss_(33).png" alt="GLP-1 Tracker App Hero" className="max-w-[280px] md:max-w-xs rounded-[2.5rem] shadow-2xl border-4 border-gray-900" data-id="element-41" />
        </motion.div>
      </motion.div>
    </section>;
}